const stripNonAlphaNumericCharacters = string =>
  string && string.replace(/\W/g, "");

export default phoneNumberString =>
  stripNonAlphaNumericCharacters(phoneNumberString);
